// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"276":"b2fea48d","535":"3e561153","539":"7f522e03","665":"631dee48","678":"43b6230f","795":"29403df2","821":"d4ffeff5","863":"dd9e31b4"}[chunkId] + ".chunk.js";
};